export default __webpack_public_path__ + "static/media/banner-lines.9686a109.svg";